import { IonButton } from '@ionic/react';
import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useWithConfirmation } from '../../../../../../../components/button/with-confirmation';

const MultipassFormResetButton = (): ReactElement => {
  const { dirty, resetForm } = useFormikContext();
  const { i18n } = useTranslation();

  const withConfirmation = useWithConfirmation({
    header: i18n.t('common:are_you_sure'),
    destructivePrompt: i18n.t('common:reset'),
  });

  const handleReset = () => {
    withConfirmation({
      onConfirmation: () => {
        resetForm();
      },
    });
  };

  return (
    <IonButton
      fill="clear"
      color={dirty ? 'primary' : 'medium'}
      disabled={!dirty}
      onClick={handleReset}
    >
      {i18n.t('common:reset')}
    </IonButton>
  );
};

export { MultipassFormResetButton };
